import type { StocktakeKind } from '@/lib/api/stocktake-api'
import { m } from '@/lib/paraglide/messages'

/**
 * Các kho kiểm kê thực tế được, theo thứ tự hiển thị. Khai một chỗ để bộ lọc
 * (màn danh sách) và ô chọn kho (màn tạo phiếu) không lệch nhau khi thêm kho.
 */
export const STOCKTAKE_KINDS: StocktakeKind[] = [
    'sorting',
    'scenting',
    'packaging',
    'product',
    'agri_materials',
]

/** Nhãn tiếng Việt per kho. Hàm (không phải chuỗi) vì m.*() phải gọi lazy. */
export const STOCKTAKE_KIND_LABELS: Record<StocktakeKind, () => string> = {
    sorting: () => m.stocktake_kind_sorting(),
    scenting: () => m.stocktake_kind_scenting(),
    packaging: () => m.stocktake_kind_packaging(),
    product: () => m.stocktake_kind_product(),
    agri_materials: () => m.stocktake_kind_agri_materials(),
}
